import type { IngameFlashType } from '@/components/IngameFlash';
import type { ServiceResponse } from '@/hooks/useTitleManager';

export type TmNotifyType = IngameFlashType;

type TranslateFn = (key: string, params?: Record<string, string | number>) => string;

const MESSAGE_I18N_KEYS: Record<string, string> = {
  'Purchase already processing.': 'tm_processing',
  'Name color purchased.': 'tm_name_purchased',
  'Name color applied.': 'tm_name_applied',
  'You already own this color.': 'tm_name_owned',
  'You already have this title.': 'tm_already_have_title',
  'You already have this tag.': 'tm_already_have_tag',
  'You already own this icon.': 'tm_already_have_icon',
  'Not enough Silk.': 'tm_not_enough_silk',
  'No Silk balance found.': 'tm_not_enough_silk',
  'Título aplicado correctamente.': 'tm_title_applied',
  'Title purchased! Enjoy your new title!': 'tm_title_purchased',
  'Title updated successfully!': 'tm_title_edited',
  'Your title has been applied successfully!': 'tm_title_applied',
  'Tag aplicado correctamente.': 'tm_tag_applied',
  'Ícono aplicado correctamente.': 'tm_icon_applied',
  'Título desactivado correctamente.': 'tm_title_removed',
  'Tag removido correctamente.': 'tm_tag_removed',
  'Ícono comprado correctamente.': 'tm_icon_purchased',
  'Title preview applied! This is temporary.': 'tm_test_applied',
};

export function isRowActive(isactive: unknown): boolean {
  return isactive == 1 || isactive === true;
}

export function findActiveRowId<T extends { id: number | string; isactive: number | boolean }>(
  rows: T[],
): number | null {
  const row = rows.find((r) => isRowActive(r.isactive));
  return row ? Number(row.id) : null;
}

export function resolveServiceMessage(message: string, t: TranslateFn): string {
  const key = MESSAGE_I18N_KEYS[message.trim()];
  return key ? t(key) : message;
}

export function notifyFromResult(
  result: ServiceResponse,
  t: TranslateFn,
  onNotify: (msg: string, type?: TmNotifyType) => void,
  fallbackErrorKey: string,
): boolean {
  if (result.retry_after) {
    onNotify(t('tm_cooldown', { seconds: result.retry_after }), 'danger');
    return false;
  }
  const msg = resolveServiceMessage(result.message, t);
  if (result.success) {
    onNotify(msg, 'success');
    return true;
  }
  onNotify(msg || t(fallbackErrorKey), 'danger');
  return false;
}
